import React, { Component } from 'react';
import { Button, Table, Jumbotron, Container, Row, OverlayTrigger, Tooltip, Col, Form } from 'react-bootstrap';
import Auth from '../../middleware/auth';
import Menu from '../menu';
import config from '../../config';
import { saveAs } from 'file-saver';
import funciones from '../../middleware/funciones';

class Impresion extends Component {
  constructor(props) {
    super(props);
    const currentCompany = sessionStorage.getItem('company');
    const currentUserType = sessionStorage.getItem('tipo');
    const state = Auth.isAuthenticated();
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
    const yyyy = today.getFullYear();
    const todayFormat = yyyy + "-" + mm + "-" + dd;


    this.state = {
      documentos: [],
      resoluciones: [],
      empresa: currentCompany,
      tipo: currentUserType,
      isLogin: state,
      searchTipo: "",
      searchTipoDian: "",
      searchNumero: "",
      searchCliente: "",
      tipo_documento: "",
      numero_inicial: "",
      numero_final: "",
      fecha_inicial: todayFormat,
      fecha_final: todayFormat
    };
  }

  componentDidMount() {
    const { empresa } = this.state
    const { tipo } = this.state
    const datasend = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'empresa': empresa,
        'tipo': tipo,
      }
    };
    fetch(config.servBackEnd + '/resoluciones/', datasend)
      .then(res => res.json())
      .then((data) => {
        this.setState({ resoluciones: data });

      })
      .catch((error) => console.error(error))
  };

  updateInfo = () =>{
    const { empresa } = this.state
    const { tipo } = this.state
    const busqueda = {
      fecha_ini: this.state.fecha_inicial,
      fecha_fin: this.state.fecha_final,
      numero_inicial: this.state.numero_inicial,
      numero_final: this.state.numero_final,
      tipo_doc: this.state.tipo_documento,
      estado: "0,1,3"
    };

    const datasend = {
      method: 'POST',
      body: JSON.stringify(busqueda),
      headers: {
        'Content-Type': 'application/json',
        'empresa': empresa,
        'tipo': tipo
      }
    }
    fetch(config.servBackEnd + '/documents/current', datasend)
      .then(res => res.json())
      .then((data) => {
        if (data.ok) {
          const datos = data.data;
          this.setState({ documentos: datos });
        }else {
          if (data.code === "0000") this.setState({ documentos: [], loading: false });
        }
      })
      .catch((error) => console.error(error))
  }


  buscar = ({ target }) => {
    const { name, value } = target;
    this.setState({ [name]: value });
  };

  getPDF = ({ target }) => {
    target.disabled = true;
    const { empresa } = this.state;
    const celda = target.parentElement;
    const fila = celda.parentElement;
    const datos = fila.children;
    //console.log(fila);
    const id = datos["id"].textContent;
    const tipo = datos["tipo"].textContent;
    const numero = datos["numero"].textContent;
    const nombreArchivo = tipo + '-' + numero + '.pdf';

    const datasend = {
      method: 'GET',
      headers: {
        'Content-Type': 'blob',
        'empresa': empresa,
        'hist': '1'
      }
    }
    fetch(config.servBackEnd + '/files/getpdf/' + id, datasend)
      .then((res) => {
        if (res.ok) return res.blob();
      })
      .then((blob) => {
        if (blob) {
          const file = new Blob([blob], { type: 'application/pdf' });
          saveAs(file, nombreArchivo);
        } else {
          //console.log("Archivo Inexistente");
        }
        target.disabled = false;
      })
      .catch((err) => {
        console.error(err);
        target.disabled = false;
      })
  };

  onePdf = ({target}) => {
    target.disabled = true;
    if(this.state.listAllPDF>=100){
      this.setState({ visObsPDF: true });
    }else{
      this.setState({ loading: true });
    }
    const { empresa } = this.state;
    const busqueda = {
      fecha_ini: this.state.fecha_inicial,
      fecha_fin: this.state.fecha_final,
      numero_inicial: this.state.numero_inicial,
      numero_final: this.state.numero_final,
      tipo_doc: this.state.tipo_documento
    };

    const datasend = {
      method: 'POST',
      body: JSON.stringify(busqueda),
      headers: {
        'Content-Type': 'application/json',
        'empresa': empresa,
        'tipo': '2'
      }
    };
    fetch(config.servBackEnd + '/files/getonepdf', datasend)
      .then((res) => {
        if (res.ok) return res.blob();
      })
      .then((blob) => {
        if (blob) {
          const file = new Blob([blob], { type: 'application/pdf' });
          saveAs(file, "facturas.pdf");
        } else {
          //console.log("Archivo Inexistente");
        }
        target.disabled = false;
        this.setState({ loading: false });
      })
      .catch((err) => {
        console.error(err);
        target.disabled = false;
        this.setState({ loading: false });
      })
  }


  render() {
    //variables
    const facturas = this.state.documentos;
    const validacionUser = this.state.isLogin;
    const searchTipo = this.state.searchTipo;
    const searchTipoDian = this.state.searchTipoDian;
    const searchNumero = this.state.searchNumero;
    const searchCliente = this.state.searchCliente;
    const {resoluciones} = this.state;
    //funciones
    const getPDF = this.getPDF;
    return (
      <div className="Menu">
        <Menu></Menu>
        <Jumbotron className="Jumbotron">
          <h2>Pre-impresion de facturas</h2>
        </Jumbotron>
        {!validacionUser && <p>La sesion se ha cerrado por favor ingrese de nuevo</p>}
        {validacionUser &&
          <div>
            <Container fluid>
              <Row className="justify-content-md-center" >
                <Col className="mb-2" xs={5} lg={1}>FECHA INICIO</Col>
                <Col className="mb-2" xs={7} lg={2}>
                  <Form.Control type="date" onChange={e => this.setState({ fecha_inicial: e.target.value })} value={funciones.formatDate(this.state.fecha_inicial)} />
                </Col>
                <Col className="mb-2" xs={5} lg={1}>FECHA FIN</Col>
                <Col className="mb-2" xs={7} lg={2}>
                  <Form.Control type="date" onChange={e => this.setState({ fecha_final: e.target.value })} value={funciones.formatDate(this.state.fecha_final)} />
                </Col>
                <Col className="mb-2" xs={5} lg={1}>TIPO</Col>
                <Col className="mb-2" xs={7} lg={1}>
                  <Form.Control as="select" onChange={e => this.setState({ tipo_documento: e.target.value })} value={this.state.tipo_documento} >
                    <option value=""></option>
                    {
                      resoluciones.map((resoluion, i) => {
                        return <option key={'td' + i} value={resoluion.PREFIJO}>{resoluion.PREFIJO}</option>;
                      })
                    }
                  </Form.Control>
                </Col>
                <Col className="mb-2" xs={5} lg={1}>NUMERO INICIAL</Col>
                <Col className="mb-2" xs={7} lg={1}>
                  <Form.Control type="number" onChange={e => this.setState({ numero_inicial: e.target.value })} value={this.state.numero_inicial} />
                </Col>
                <Col className="mb-2" xs={5} lg={1}>NUMERO FINAL</Col>
                <Col className="mb-2" xs={7} lg={1}>
                  <Form.Control type="number" onChange={e => this.setState({ numero_final: e.target.value })} value={this.state.numero_final} />
                </Col>
                <Col className="mb-2" xs={12} lg={2}>
                  <Button id="actualizar" name="actualizar" onClick={this.updateInfo}  >Actualizar Documentos </Button>
                </Col>
                <Col className="mb-2" xs={12} lg={2}>
                  <Button id="actualizar" disabled={facturas.length===0} name="actualizar" onClick={this.onePdf}  >Generar PDF</Button>
                </Col>
              </Row>
              <Row>
                <Table hover bordered responsive size="sm" className="table">
                  <thead>
                    <tr>
                      <th><input type="text" maxLength="2" size="3" name="searchTipo" onChange={this.buscar} /></th>
                      <th><input type="text" maxLength="4" size="5" name="searchTipoDian" onChange={this.buscar} /></th>
                      <th><input type="text" maxLength="10" size="11" name="searchNumero" onChange={this.buscar} /></th>
                      <th><input type="text" maxLength="10" size="11" name="searchCliente" onChange={this.buscar} /></th>
                    </tr>
                    <tr>
                      <th>Tipo Documento</th>
                      <th>Prefijo Dian</th>
                      <th>Numero Documento</th>
                      <th>Nombre Cliente</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {facturas.map(function (currentData, index) {
                      if (currentData.TIPO_DOCUMENTO_CABECERA.toLowerCase().search(searchTipo.toLowerCase()) > -1
                        && currentData.PREFIJO_DIAN.toLowerCase().search(searchTipoDian.toLowerCase()) > -1
                        && currentData.NUMERO_FACTURA_CABECERA.toLowerCase().search(searchNumero.toLowerCase()) > -1
                        && currentData.DOCUMENTO_CLIENTE.toLowerCase().search(searchCliente.toLowerCase()) > -1
                      ) {
                        return <tr key={index + "d0"}>
                          <td name="tipo" key={index + "d1"}>{currentData.TIPO_DOCUMENTO_CABECERA}</td>
                          <td name="dian" key={index + "d2"}>{currentData.PREFIJO_DIAN}</td>
                          <td name="numero" key={index + "d3"}>{currentData.NUMERO_FACTURA_CABECERA}</td>
                          <td name="cliente" key={index + "d4"}>{currentData.DOCUMENTO_CLIENTE}</td>
                          <OverlayTrigger placement='top-start' overlay={<Tooltip>Descargar Representacion Grafica</Tooltip>}>
                            <td key={index + "d10"}><Button className="buttonP" onClick={getPDF} variant="outline-primary"></Button></td>
                          </OverlayTrigger>
                          <td name="id" className="d-none" key={index + "d15"}>{currentData.ID_FACTURA}</td>
                        </tr>;
                      } else {
                        return <tr key={index + "f0"}></tr>
                      }
                    })}
                  </tbody>
                </Table>
              </Row>
            </Container>
          </div>
        }
      </div>
    );
  }
}
export default (Impresion);